import getTacticalOffers from '../../integration/tacticalOffers.api';

const getMbbDisplayNames = code => {
  const data = JSON.parse(localStorage.getItem('ACQ_MBB_TARRIFS'));
  const filteredTariff = data?.filter(offers => offers.description === code);
  const result = filteredTariff?.[0]?.displayName;
  return result;
};

const calculateActivationFeeDiscount = (broadbandTechnology, discountedOneOffAmount) => {
  const FTHActivationFee = 14998;
  const FTCActivationFee = 4999;
  let calculatedActivationFeeDiscount = 0;
  if (broadbandTechnology === 'FTTC') {
    calculatedActivationFeeDiscount = FTCActivationFee - discountedOneOffAmount;
  } else if (broadbandTechnology === 'FTTH') {
    calculatedActivationFeeDiscount = FTHActivationFee - discountedOneOffAmount;
  }
  return calculatedActivationFeeDiscount;
};
const structureActivationData = (activationFee, serviceType, broadbandTechnology) => ({
  title: 'Activation Fee',
  price:
    activationFee?.discountedOneOffAmount > 0
      ? activationFee?.discountedOneOffAmount
      : activationFee?.discountedUpFrontAmount,
  discountedPrice: activationFee?.oneOffAmount,
  serviceType,
  activationFeeDiscount: calculateActivationFeeDiscount(
    broadbandTechnology,
    activationFee?.discountedOneOffAmount
  ),
  broadbandTechnology,
  offerId: activationFee?.id,
});

const structureTopUpAmount = (amount, id, planPrice) => ({
  title: 'Additional credit',
  price: amount - planPrice,
  itemType: 'additionalTopUp',
  offerId: id,
});
const structureAddOns = (add, serviceType, offerId) => ({
  title: add?.displayName || add?.description,
  price: add?.amountVatIncluded?.recurringAmount?.discountedAmount,
  serviceType,
  offerId,
  addOnId: add?.id,
  contractLength: 'Monthly subscription',
});

const structurePrepayAddOns = (add, serviceType, offerId) => ({
  title: add?.displayName || add?.description,
  price: add?.amountVatIncluded?.recurringAmount?.discountedAmount,
  serviceType,
  offerId,
  addOnId: add?.id,
  contractLength:
    add?.amountVatIncluded?.recurringAmount?.discountedAmount === 2000
      ? '3,000 Irish minutes & texts.'
      : 'Top up every 14 days.', // copy to be displayed as workground till it derives from OCAT
  itemType: add?.itemGroup,
  discount: add?.discounts,
});
const structureTacticalOffers = toff => ({
  title: toff?.heading,
  description: `${toff?.heading} ${toff?.copy}`,
});
const structureDeposit = deposit => ({
  title: 'Handset Deposit',
  price: deposit?.depositAmountVatIncluded,
  description:
    'This is an advanced payment which will be credited to your account on your 7th bill',
});
const structureOfferDiscount = (discount, serviceType) => ({
  description: discount?.description,
  billType: discount?.billingType,
  catalogCode: discount?.catalogCode,
  value:
    discount?.billingType === 'RECURRING'
      ? `of €${(discount.value / 100).toFixed(2)}/month`
      : `of €${(discount.value / 100).toFixed(2)}`,
  serviceType,
});

const createAddonDisplayName = description => {
  const index = description?.toUpperCase().indexOf('BAND');
  if (index !== -1) {
    const displayName = description?.substring(0, index);
    return displayName;
  }
};

const structureInsuranceAddOnData = (insuranceEquipment, offerId) => ({
  title: createAddonDisplayName(insuranceEquipment?.addOn?.description),
  itemType: insuranceEquipment?.addOn?.itemGroup,
  price: insuranceEquipment?.addOn?.amountVatIncluded?.recurringAmount.amount,
  discountedPrice: insuranceEquipment?.addOn?.amountVatIncluded?.recurringAmount.discountedAmount,
  offerCode: insuranceEquipment?.addOn?.catalogCode,
  equipmentId: insuranceEquipment?.id,
  addOnId: insuranceEquipment?.addOn?.id,
  offerId,
});

const getSIMCardType = simCardTypes => {
  let equipmentType;
  if (simCardTypes) {
    if (simCardTypes.includes('NANO') && simCardTypes.includes('ESIM')) {
      equipmentType = 'HYBRID';
    } else if (simCardTypes.includes('NANO')) {
      equipmentType = 'PSIM';
    } else if (simCardTypes.includes('ESIM')) {
      equipmentType = 'ESIM';
    }
  }
  return equipmentType;
};
const structureHandsetData = (handset, offerId) => ({
  title: handset?.model,
  itemType: handset?.type,
  price: handset?.amountVatIncluded?.discountedUpFrontAmount,
  discountedPrice: handset?.amountVatIncluded?.upFrontAmount,
  variant: `${handset?.color} - ${handset?.capacity}`,
  SIMCardType: handset?.simCardTypes ? getSIMCardType(handset?.simCardTypes) : '',
  offerCode: handset?.inventoryCode,
  handsetId: handset?.id,
  offerId,
  insuranceAddOnData: structureInsuranceAddOnData(handset, offerId),
});

const structureMbbDongleData = (handset, offerId) => ({
  title: `${handset?.manufacturer} ${handset?.model}`,
  itemType: handset?.type,
  price: handset?.amountVatIncluded?.discountedUpFrontAmount,
  discountedPrice: handset?.amountVatIncluded?.upFrontAmount,
  offerCode: handset?.catalogCode,
  equipmentId: handset?.id,
  offerId,
});

const structureCartData = cartData => ({
  title:
    cartData?.baseOffer?.serviceGroup === 'MBB'
      ? getMbbDisplayNames(cartData?.baseOffer?.description)
      : cartData?.baseOffer?.description,
  itemType: cartData?.baseOffer?.serviceGroup,
  isSimOnly: cartData?.baseOffer?.simOnly,
  SIMCode:
    cartData?.baseOffer?.serviceGroup === 'MOBILE'
      ? cartData?.inclusiveEquipments[0]?.inclusiveEquipmentCatalogCode
      : '',
  discountedPrice: cartData?.baseOffer?.amountVatIncluded?.recurringAmount?.amount,
  price: cartData.baseOffer?.amountVatIncluded?.recurringAmount?.discountedAmount,
  contractLength: cartData?.baseOffer?.simOnly
    ? `for ${cartData?.baseOffer?.amountVatIncluded?.recurringAmount?.discountOccurrence} months`
    : `for ${cartData?.baseOffer?.commitmentDuration} months`,
  // eslint-disable-next-line no-unsafe-optional-chaining
  afterPrice: `, €${(cartData?.baseOffer?.amountVatIncluded?.recurringAmount?.amount / 100).toFixed(
    2
  )} per month thereafter`,
  portInPhoneNumber: cartData?.portInInfo
    ? `${cartData?.portInInfo?.msisdn?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')} `
    : '',
  portingDate: cartData?.portInInfo ? cartData?.portInInfo?.portStartDateTime : '',
  portIn: cartData?.baseOffer?.portIn,
  portInInfo: Boolean(cartData?.portInInfo),
  offerId: cartData?.id,
  offerCode: cartData?.baseOffer.catalogTariffPlanCode,
  speed: cartData?.baseOffer?.minDownloadSpeed,
  modemCompatible: cartData?.modemCompatible,
  appointmentType: cartData?.appointment?.type,
  appointmentRequired: cartData?.appointment,
  activation: structureActivationData(
    cartData?.activationFeeVatIncluded,
    cartData?.baseOffer.serviceGroup,
    cartData?.baseOffer.broadbandTechnology
  ),
  discountData: cartData?.discounts?.map(discount =>
    structureOfferDiscount(discount, cartData.baseOffer.serviceGroup)
  ),
  addOns: cartData?.addOns?.map(ad =>
    structureAddOns(ad, cartData?.baseOffer?.serviceGroup, cartData.id)
  ),
  handsetData: cartData?.equipments?.map(ad =>
    structureHandsetData(ad, cartData?.id, cartData?.baseOffer?.serviceGroup)
  ),
  mbbDongle: cartData?.equipments?.map(ad =>
    structureMbbDongleData(ad, cartData?.id, cartData?.baseOffer?.serviceGroup)
  ),
  prepayAddons: cartData?.addOns?.map(ad =>
    structurePrepayAddOns(ad, cartData?.baseOffer?.serviceGroup, cartData.id)
  ),
  topUpAmount: structureTopUpAmount(
    cartData?.topUpAmount,
    cartData.id,
    cartData?.amountVatIncluded?.recurringAmount?.discountedAmount
  ),
});

/**
 *
 * @param {*} cart
 * @returns {
 *   haveOffer,
 *   numberOfOffers,
 *   hasUpfrontCostItem,
 *   numberOfDevices,
 *   haveMobileOffers,
 *   havehaveBroadbandOffersOffer,
 *   haveTvOffers,
 *   isPortInDone
 * }
 */
export const getCartInfo = cart => {
  // const { offers } = cart;
  const portInOffers = cart?.offers?.filter(
    offer => offer?.baseOffer?.serviceGroup === 'MOBILE' && offer.baseOffer.portIn
  );
  // change this to additionalAllowedOffers, when cart service is ready
  const additionalAllowedOffers = cart?.additionalAllowedOffers?.filter(
    sg => sg.serviceGroup === 'MOBILE'
  )[0]?.number;
  const insuranceAddons = cart?.offers
    ?.map(offer => offer?.equipments?.map(add => add?.addOn))
    .flat();

  return cart?.offers?.length > 0
    ? {
        haveOffer: cart?.offers?.length > 0,
        numberOfOffers: cart?.offerType === 'PREPAY' ? 0 : cart?.offers?.length, // Offers should not be counted for PREPAY
        hasUpfrontCostItem: cart?.offers?.filter(offer => offer?.equipments?.length > 0).length > 0,
        numberOfDevices: cart?.offers
          ?.map(offer => offer?.equipments?.length)
          .reduce((a, b) => a + b),
        numberOfAddOns: cart?.offers?.map(off => off?.addOns?.length).reduce((a, b) => a + b),
        numberOfInsuranceAddOns: insuranceAddons?.filter(ele => ele).length,
        haveMobileOffers:
          cart?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'MOBILE').length > 0,
        haveBroadbandOffers:
          cart?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'DUALPLAY').length > 0,
        haveTvOffers:
          cart?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'TV').length > 0,
        // porti: offers.length > 0,
        // if portin offers and schedule done then true or else false
        isPortInDone:
          portInOffers?.length === 0 ||
          !portInOffers?.map(offer => Boolean(offer.portInInfo)).includes(false),
        additionalAllowedOffers,
        noOfMobileOffers: cart?.offers.filter(offer => offer.baseOffer.serviceGroup === 'MOBILE')
          .length,
        offerType: cart?.offerType,
      }
    : {
        haveOffer: false,
        hasUpfrontCostItem: false,
        numberOfOffers: 0,
        numberOfDevices: 0,
        numberOfAddOns: 0,
        numberOfInsuranceAddOns: 0,
        portInInfo: null,
        additionalAllowedOffers,
      };
};
/**
 *
 * @param {Object} cartResult - cart data
 * @returns - props required for cart container
 */
export const getCartDetails = cartResult => {
  let result = {};
  // const cartResult = await getCarts({ graphql, variables });
  const monthlyTotalPrice = cartResult?.amountVatIncluded?.recurringAmount?.discountedAmount;
  const payTodayTotalPrice = cartResult?.amountVatIncluded?.discountedUpFrontAmount;
  const portInOffers = cartResult?.offers?.filter(
    offer => offer.baseOffer.serviceGroup === 'MOBILE' && offer.baseOffer.portIn
  );
  const deliveryRequired = cartResult?.deliveryRequired;
  const activationDateRequired = cartResult?.activationDateRequired;

  const activation = cartResult?.offers?.map(act => act.activationFeeVatIncluded);

  const isActivationAvailable = activation?.length > 0;

  const hasDicountedUpFrontAmount = cartResult?.amountVatIncluded?.discountedUpFrontAmount > 0;
  const onceOffAmount = cartResult?.amountVatIncluded?.oneOffAmount;
  const discountedOnceOffAmount = cartResult?.amountVatIncluded?.discountedOneOffAmount;
  const hasUpfrontCostItem =
    cartResult?.offers?.filter(offer => offer?.equipments?.length > 0).length > 0;
  const hasBroadband =
    cartResult?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'DUALPLAY').length > 0;
  const hasTVOffer =
    cartResult?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'TV').length > 0;
  const hasUpfrontSIMOPlans =
    cartResult?.offers?.filter(
      offer =>
        offer.baseOffer.serviceGroup === 'MOBILE' &&
        offer.baseOffer.simOnly === true &&
        offer.activationFeeVatIncluded.discountedUpFrontAmount > 0
    ).length > 0;
  const hasBillPayPlans =
    cartResult?.offers?.filter(
      offer => offer.baseOffer.serviceGroup === 'MOBILE' && offer.baseOffer.simOnly === false
    ).length > 0;
  const hasSIMOnly =
    cartResult?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'MOBILE').length > 0 &&
    cartResult?.offers?.filter(offer => offer?.baseOffer?.simOnly === true).length > 0;
  const hasMBBOffer =
    cartResult?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'MBB').length > 0;
  const noOfMobileOffers = cartResult?.offers?.filter(
    offer => offer.baseOffer.serviceGroup === 'MOBILE' && offer.baseOffer.simOnly === true
  ).length;
  const noOfBillPayOffers = cartResult?.offers?.filter(
    offer => offer.baseOffer.serviceGroup === 'MOBILE' && offer.baseOffer.simOnly === false
  ).length;

  const hasPrepayMobile =
    cartResult?.offers?.filter(offer => offer.baseOffer.serviceGroup === 'MOBILE').length > 0;
  const isPortInDone =
    portInOffers?.length === 0 ||
    !portInOffers?.map(offer => Boolean(offer.portInInfo)).includes(false);
  const hasAddOns = cartResult?.offers.map(add => add?.addOns?.length > 0);
  const hasMbbDevice = cartResult?.offers.filter(offer => offer?.equipments?.length > 0).length > 0;
  const hasHandsetDeposit =
    cartResult?.offers?.filter(
      offer => offer?.baseOffer?.serviceGroup === 'MOBILE' && offer.depositAmountVatIncluded > 0
    ).length > 0;
  const offerType = cartResult?.offerType;
  result = {
    cart: cartResult?.offers?.map(cartData =>
      structureCartData(cartData, hasSIMOnly, hasUpfrontCostItem)
    ),
    handset: cartResult?.offers.map(offers =>
      offers?.equipments?.map(handset => structureHandsetData(handset, offers.id))
    ),

    activationData: cartResult?.offers?.map(activationFee =>
      structureActivationData(activationFee, activationFee.baseOffer.serviceGroup)
    ),
    discountData: cartResult?.offers.map(offers =>
      offers?.discounts?.map(discount =>
        structureOfferDiscount(discount, offers?.baseOffer?.serviceGroup)
      )
    ),
    despositInfo: cartResult?.offers?.map(deposit =>
      structureDeposit(deposit, deposit?.baseOffer?.serviceGroup)
    ),
    offerItem: cartResult?.offers
      ?.map(cartData => structureCartData(cartData, hasSIMOnly, hasUpfrontCostItem))
      .concat(
        cartResult?.offers?.map(activationFee =>
          structureActivationData(activationFee, activationFee?.baseOffer?.serviceGroup)
        )
      ),
    hasUpfrontCostItem:
      cartResult?.offers.filter(offer => offer?.equipments?.length > 0).length > 0,
    isActivationAvailable,
    hasDicountedUpFrontAmount,
    hasBroadband,
    hasTVOffer,
    hasBillPayPlans,
    hasUpfrontSIMOPlans,
    hasSIMOnly,
    hasMBBOffer,
    isPortInDone,
    noOfMobileOffers,
    noOfBillPayOffers,
    hasPrepayMobile,
    hasAddOns,
    onceOffPrice: onceOffAmount,
    discountedOnceOffPrice: discountedOnceOffAmount,
    payTodayTotal: payTodayTotalPrice,
    monthlyTotal: monthlyTotalPrice,
    hasMbbDevice,
    deliveryRequired,
    activationDateRequired,
    hasHandsetDeposit,
    offerType,
    topUpList: cartResult?.availableTopUp,
  };
  return result;
};

/**
 * 
 * @param {*} showCart 
 * @param {*} showNextButton 
 * @param {*} disablenNextButton 
 * @param {*} nextMethod 
 * @param {*} showCheckoutButton 
 * @param {*} disableCheckoutButton 
 * @param {*} cart 
 * @param {*} dispatch 
 
 */
export const displayCart = ({
  showCart = true,
  showCheckoutButton = false,
  showNextButton = true,
  nextMethod,
  disablenNextButton = true,
  disableCheckoutButton = true,
  cart,
  dispatch,
  handleMobileOnloadDisplay,
}) => {
  const cartInfo = getCartInfo(cart);
  if (cartInfo.haveOffer) {
    dispatch({ type: 'SHOW_CART', payload: true });
    dispatch({
      type: 'SET_NEXT_BUTTON_METHOD',
      payload: {
        show: showNextButton,
        enable: !disablenNextButton,
        action: nextMethod,
      },
    });
    dispatch({
      type: 'SET_CHECKOUT_BUTTON',
      payload: {
        show: showCheckoutButton,
        enable: !disableCheckoutButton,
      },
    });
  } else if (handleMobileOnloadDisplay) {
    dispatch({ type: 'SHOW_CART', payload: false });
  } else dispatch({ type: 'SHOW_CART', payload: showCart });
};
export const getTacticalOfferDetails = async graphql => {
  try {
    const tacticalOffers = await getTacticalOffers({
      graphql,
      variables: { serviceGroupCode: 'DUALPLAY' },
    });
    const tactData = tacticalOffers?.map(tact => structureTacticalOffers(tact));
    return tactData;
  } catch (err) {
    console.error(err);
    return null;
  }
};
